"use strict";
(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @fancyapps/fancybox */ "./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");





var mq = {
  sm: 576,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
jQuery(function () {
  var replaceMenu = function replaceMenu() {
    if ($(window).width() < mq.lg) {
      $(".js-panel-bottom").append($(".js-top-menu"));
      $(".js-panel-top").prepend($(".js-main-menu-left"));
      $(".js-filter-panel-inner").prepend($(".js-collection-filters"));
      $(".js-header-bottom").prepend($(".js-search-form"));
    } else {
      $(".js-search-wrapper").prepend($(".js-search-form"));
      $(".js-main-menu").prepend($(".js-main-menu-left"));
      $(".js-top-nav").prepend($(".js-top-menu"));
      $(".js-search-wrapper").prepend($(".js-search-form"));
      $(".panel").removeClass("panel-active");
      $(".nav-toggle").removeClass("is-active");
      $(".js-collection-filters-aside").prepend($(".js-collection-filters"));
      $("body, html").removeClass("lock");
      $(".js-header-toggle").removeClass("is-active");
      $("html").removeClass("filters-active");
    }
  };
  replaceMenu();
  $(window).on("resize", function () {
    replaceMenu();
    headerScroll();
    adjustPanelHeights();
  });

  // Functie om de scroll status van de header te controleren en de hoogte van het paneel aan te passen
  function headerScroll() {
    if ($(window).scrollTop() > 48) {
      // Voeg de 'scrolled' klasse toe als er meer dan 40px is gescrold
      $(".js-header").addClass("scrolled");
      $("html").addClass("is-scrolled");
    } else {
      // Verwijder de 'scrolled' klasse als er minder dan 40px is gescrold
      $(".js-header").removeClass("scrolled");
      $("html").removeClass("is-scrolled");
    }
    // Pas de hoogte van het paneel aan na het controleren van de scroll status
    adjustPanelHeights();
  }

  // Roep de functie aan bij het laden van de pagina
  headerScroll();

  // Voeg een scroll event listener toe om de headerScroll functie aan te roepen wanneer er wordt gescrold
  $(window).on("scroll", function () {
    headerScroll();
  });

  // Functie om de hoogte van het paneel aan te passen op basis van de hoogte van de header
  function adjustPanelHeights() {
    var headerElement = document.querySelector(".header");
    var headerHeight = headerElement.offsetHeight;
    var panelElement = document.querySelector(".panel");
    var filterElement = document.querySelector(".js-filters");
    var panelTop = 0;
    if ($(window).width() < mq.lg) {
      // Check if the HTML is already locked or active with panel
      if ($("html").hasClass("lock") || $("html").hasClass("filters-active")) {
        // Check extra for the scrolled class because of the height of the search
        panelTop = $(".js-header").hasClass("scrolled") ? headerHeight - 44 : headerHeight;
      } else {
        panelTop = headerHeight - 44;
      }
    } else {
      panelTop = headerHeight;
    }
    panelElement.style.top = panelTop + "px";
    if (filterElement) {
      filterElement.style.top = panelTop + "px";
    }
  }

  // Roep de functie aan bij het laden van de pagina om de paneelhoogtes correct in te stellen
  adjustPanelHeights();

  // Voeg een click event listener toe aan de .js-header-toggle om de header status te togglen
  $(document).on("click", ".js-header-toggle", function (e) {
    e.preventDefault();
    $(this).toggleClass("is-active");
    adjustPanelHeights();
    $("html").toggleClass("lock");
    $("html").removeClass("filters-active");
  });
  $(document).on("click", ".js-product-filters", function (e) {
    e.preventDefault();
    adjustPanelHeights();
    $("html").toggleClass("filters-active");
    $("body").removeClass("lock");
    $("html").removeClass("lock");
  });
  $(document).on("click", ".js-collection-panel-toggle", function (e) {
    e.preventDefault();
    console.log('123');
    adjustPanelHeights();
    $("html").removeClass("filters-active");
  });
});

/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeFilterPanel: () => (/* binding */ closeFilterPanel),
/* harmony export */   filterToggle: () => (/* binding */ filterToggle),
/* harmony export */   lockHTML: () => (/* binding */ lockHTML),
/* harmony export */   openFilterPanel: () => (/* binding */ openFilterPanel),
/* harmony export */   unlockHTML: () => (/* binding */ unlockHTML)
/* harmony export */ });
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var filterToggle = function filterToggle(element) {
  if (element.parent().hasClass('is-hidden')) {
    element.parent().removeClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  } else {
    element.parent().addClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  }
};
var openFilterPanel = function openFilterPanel() {
  $(".drawer-filter").toggleClass("is-open");
};
var closeFilterPanel = function closeFilterPanel() {
  $(".drawer-filter").removeClass("is-open");
};
var lockHTML = function lockHTML() {
  if (!$("html").hasClass("is-locked")) {
    $("html").addClass("is-locked");
  }
};
var unlockHTML = function unlockHTML() {
  if ($("html").hasClass("is-locked")) {
    $("html").removeClass("is-locked");
  }
};


/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/**
 * Header slider
 **/

var mq = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600
};
jQuery(function () {
  $(".js-header-usp-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true
  });
  $(".js-home-news-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: false,
    responsive: [{
      breakpoint: mq.lg,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: mq.md,
      settings: {
        slidesToShow: 1.5
      }
    }]
  });
  $(".js-home-collection-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    variableWidth: false,
    rows: 0,
    infinite: true,
    responsive: [{
      breakpoint: mq.xxxl,
      settings: {
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }, {
      breakpoint: mq.xl,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: mq.lg,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: mq.md,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: mq.sm,
      settings: {
        slidesToShow: 1.5
      }
    }]
  });
  $(".js-home-products-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [{
      breakpoint: mq.xxl,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: mq.xl,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: mq.lg,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: mq.sm,
      settings: {
        slidesToShow: 1.5,
        infinite: false
      }
    }]
  });
  $(".js-product-upsell-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    rows: 1,
    responsive: [{
      breakpoint: mq.xxl,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: mq.xl,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: mq.lg,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: mq.sm,
      settings: {
        slidesToShow: 1.5,
        infinite: false
      }
    }]
  });
  $(".js-product-hero-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".js-product-hero-nav"
  });
  $(".js-product-hero-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".js-product-hero-slider",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    rows: 1,
    vertical: true,
    verticalSwiping: true,
    responsive: [{
      breakpoint: mq.lg,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: mq.md,
      settings: {
        slidesToShow: 2,
        vertical: false,
        verticalSwiping: false,
        variableWidth: true
      }
    }, {
      breakpoint: mq.sm,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false,
        variableWidth: true
      }
    }]
  });
});

/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");


/**
 * Menu toggles
 **/

$(document).on("click", ".js-mega-menu-toggle i", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).parent().find(".megamenu").toggleClass("is-active");
});
$(document).on("click", ".js-sub-menu-title i", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next(".child-menu").slideToggle();
});
$(document).on("click", ".js-megamenu-return", function (e) {
  e.preventDefault();
  $(this).closest(".megamenu").removeClass("is-active");
});
$(document).on("click", ".js-search-bg", function (e) {
  e.preventDefault();
  $(this).removeClass("search__bg--open");
  $(".ajax-search-results").addClass("d-none");
  $("html").removeClass("locking");
});
$(document).keydown(function (event) {
  if (event.key === "Escape") {
    $("html").removeClass("locking");
    $(".js-search-bg").removeClass("search__bg--open");
    $(".ajax-search-results").addClass("d-none");
  }
});

/**
 * FAQ toggles
 **/

$(document).on("click", ".js-faq-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).next().stop().slideToggle(300);
});

/**
 * Product filter toggle
 **/
$(document).on("click", ".js-collection-filter-toggle", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.filterToggle)($(this));
});

// Filterpanel openen/sluiten
$(document).on("click", ".js-header-collection-mobile-filter", function (e) {
  openFilterPanel();
  lockHTML();
});
$(document).ready(function () {
  $('a[href^="#"]').on('click', function (event) {
    // Voorkom de standaard actie van de link
    event.preventDefault();

    // Haal de hash (id) op van de link
    var target = this.hash;

    // Gebruik jQuery om het doel element te selecteren
    var $target = $(target);

    // Controleer of het doel element bestaat
    if ($target.length) {
      // Bepaal de offset afhankelijk van de schermbreedte
      var offset = $(window).width() < 992 ? 80 : 140;

      // Animeren van de scroll met de berekende offset
      $('html, body').animate({
        scrollTop: $target.offset().top - offset
      }, 800); // 800 ms animatie duur
    }
  });
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);